import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, MessageCircleIcon } from 'lucide-react';
import { LanguageToggle } from './LanguageToggle';
import { useLanguage } from '../../contexts/LanguageContext';
import { business } from '../../data/site';
import { whatsappLink } from '../../utils/whatsapp';
export function Footer() {
  const {
    t
  } = useLanguage();
  const nav = t.common.nav;
  const ft = t.common.footer;
  const quick = [{
    label: nav.home,
    to: '/'
  }, {
    label: nav.services,
    to: '/services'
  }, {
    label: nav.portfolio,
    to: '/portfolio'
  }, {
    label: nav.reviews,
    to: '/reviews'
  }, {
    label: nav.faq,
    to: '/faq'
  }, {
    label: nav.process,
    to: '/process'
  }, {
    label: nav.about,
    to: '/about'
  }, {
    label: nav.contact,
    to: '/contact'
  }];
  const heading = 'text-xs font-medium uppercase tracking-wider2 text-champagne';
  const link = 'text-sm text-white/75 transition-colors duration-150 ease-smooth hover:text-white';
  return <footer className="bg-ink text-white/80" data-id="element-136" data-mp="2kcl49b8j6px8">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8" data-id="element-137" data-mp="2kbjpavoe9ja8">
        <div className="grid gap-10 border-b border-white/10 pb-12 lg:grid-cols-12" data-id="element-138" data-mp="2p433nuuwoig3">
          <div className="lg:col-span-4" data-id="element-139" data-mp="2bcyc7g1oywgu">
            <p className="font-display text-2xl font-semibold text-white" data-id="element-140" data-mp="2bdzmhiavvexi">Flores con Aroma de Café</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/70" data-id="element-141" data-mp="2gbrgqiz03d4v">{ft.blurb}</p>
            <div className="mt-6" data-id="element-142" data-mp="341lqusrxqnlf">
              <LanguageToggle tone="dark" data-id="element-143" data-mp="382p6pf9zgjmn" />
            </div>
          </div>

          <nav aria-label={ft.quickLinks} className="lg:col-span-2" data-id="element-144" data-mp="380l5x67ds0ql">
            <p className={heading} data-id="element-145" data-mp="2u24nii05olsm">{ft.quickLinks}</p>
            <ul className="mt-5 space-y-3" data-id="element-146" data-mp="2z20rwicrmf8p">
              {quick.map(l => <li key={l.to} data-id="element-147" data-mp="2z43ppok5tcnz">
                  <Link to={l.to} className={link} data-id="element-148" data-mp="1in7y37027ukq">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label={ft.services} className="lg:col-span-3" data-id="element-149" data-mp="1nkhlyi7svy6g">
            <p className={heading} data-id="element-150" data-mp="13k7x2fft95pm">{ft.services}</p>
            <ul className="mt-5 space-y-3" data-id="element-151" data-mp="zimag2dh5d28">
              {t.services.items.map(s => <li key={s.slug} data-id="element-152" data-mp="us5x0i9nlrfv">
                  <Link to={`/services/${s.slug}`} className={link} data-id="element-153" data-mp="ure3dczma3s8">
                    {s.title}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-154" data-mp="kvaza1l7fv2n">
            <p className={heading} data-id="element-155" data-mp="ks5ayokegx7z">{ft.contact}</p>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-156" data-mp="fuvlj8x0glk5">
              <li data-id="element-157" data-mp="fxhw7hf77h6l">
                <a href={business.phoneHref} className={link} data-id="element-158" data-mp="bta3l95mdh33">
                  {business.phoneIntl}
                </a>
              </li>
              <li data-id="element-159" data-mp="6vs3875o4a6p">
                <a href={whatsappLink()} target="_blank" rel="noreferrer" className={link} data-id="element-160" data-mp="6wb9gqlyha4w">
                  WhatsApp · {business.phoneDisplay}
                </a>
              </li>
              <li data-id="element-161" data-mp="219syyj5x8h2k">
                <a href={`mailto:${business.email}`} className={`${link} break-all`} data-id="element-162" data-mp="216eyxhkqcjya">
                  {business.email}
                </a>
              </li>
              <li className="text-white/60" data-id="element-163" data-mp="2dq268014ic7n">{ft.hours}</li>
              <li className="text-white/60" data-id="element-164" data-mp="2ihtz4h7r4u0y">{ft.area}</li>
              <li data-id="element-165" data-mp="2ij558noo6dv8">
                <a href={business.directions} target="_blank" rel="noreferrer" className={`${link} underline underline-offset-4`} data-id="element-166" data-mp="2ijwz9u2mc3je">
                  {ft.directions}
                </a>
              </li>
            </ul>

            <p className={`${heading} mt-8`} data-id="element-167" data-mp="1us80pvz7eiu0">{ft.social}</p>
            <div className="mt-4 flex gap-3" data-id="element-168" data-mp="1usrjfewohb93">
              <Social href={business.social.instagram} label={`Instagram ${business.instagramHandle}`} icon={InstagramIcon} data-id="element-169" data-mp="1zrkmsei93lvj" />
              <Social href={business.social.facebook} label="Facebook" icon={FacebookIcon} data-id="element-170" data-mp="23t65ighguudn" />
              <Social href={whatsappLink()} label="WhatsApp" icon={MessageCircleIcon} data-id="element-171" data-mp="3b799r5vi8kwc" />
            </div>
            <p className="mt-3 text-xs text-white/50" data-id="element-172" data-mp="3f7bddkksvoe9">{business.instagramHandle}</p>
          </div>
        </div>

        <p className="pt-6 text-xs text-white/50" data-id="element-173" data-mp="3drp595ktaqkp">
          © {new Date().getFullYear()} Flores con Aroma de Café. {ft.rights}
        </p>
      </div>
    </footer>;
}
function Social({
  href,
  label,
  icon: Icon
}: {
  href: string;
  label: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}) {
  return <a href={href} target="_blank" rel="noreferrer" aria-label={label} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 transition-colors duration-150 ease-smooth hover:border-champagne hover:text-champagne" data-id="element-174" data-mp="3iopchjtedzde">
      <Icon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="a9nrygwksnn5" />
    </a>;
}